import { v1ApiClient } from '@/services';
import type { Operation, Schema } from '@/shared/api/generated';

type RetrieveAggregatedReportsOperation =
  Operation<'RetrieveAggregatedReports'>;

export type GetAggregatedReportListParams =
  RetrieveAggregatedReportsOperation['parameters']['path'] &
  RetrieveAggregatedReportsOperation['parameters']['query'];

export type GetAggregatedReportListResponse =
  Schema<'RetrieveAggregatedReportsResponse'>;

export type AggregatedReportListItem = Schema<'AggregatedReportInList'>;

export const getAggregatedReportList = ({
  workspace_id,
  ...params
}: GetAggregatedReportListParams): Promise<GetAggregatedReportListResponse> =>
  v1ApiClient
    .get(`/workspaces/${workspace_id}/aggregated-reports`, {
      params,
    })
    .then((res) => res.data);
